<script setup lang="ts">
const { iconColor, modelValue, items } = defineProps<{
  iconColor: String,
  modelValue: Boolean,
  items: IPage[]
}>()

const active: Ref<boolean> = ref(modelValue)
</script>

<template>
  <v-icon
      @click="active = !active"
      size="32"
      :color="iconColor"
  >las la-bars</v-icon>
  <v-navigation-drawer
      v-model="active"
      location="right"
      temporary :elevation="2"
      :width="300"
  >
    <MenuContent
        v-if="active"
      :items="items"
      @close="active = false"
    />
  </v-navigation-drawer>
</template>

<style scoped lang="scss">
.v-icon {
  position: absolute;
  top: 33px;
  right: 24px;
  cursor: pointer;
}
</style>